import React, { useState } from 'react';
import { useDocumentApi } from '../../features/auth/hooks/use-document-api.ts';
import { ApiResponseType } from '../../features/api/types.ts';
import '../../scss/components/Documentcenter.scss';


const FileItem = ({
    item
}) => {
    const { getDocument } = useDocumentApi();

    const [fileIsLoading, setFileIsLoading] = useState('');

    const isImageFile = (filePath: string): boolean => {
        const imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'svg', 'webp', 'tiff', 'ico'];
        const extension = filePath.split('.').pop()?.toLowerCase();
        return extension ? imageExtensions.includes(extension) : false;
    }

    const base64ToArrayBuffer = (base64:string) => {
        const binaryString =  window.atob(base64);
        const binaryLen = binaryString.length;
        const bytes = new Uint8Array(binaryLen);
        for (let i = 0; i < binaryLen; i++)        {
            const ascii = binaryString.charCodeAt(i);
            bytes[i] = ascii;
        }
        return bytes;
    }

    const openFile = (base64:string, mimeType:string, name:string) => {
        const arrayBuffer = base64ToArrayBuffer(base64);
        const blob = new Blob([arrayBuffer], { type: mimeType });
        const url = window.URL.createObjectURL(blob);
        if (mimeType === 'application/pdf') {            
            let fileLink = document.createElement('a');
            fileLink.href = url;
            fileLink.download = name + (!name.endsWith('.pdf') ? '.pdf' : '');
            fileLink.click();
            fileLink.remove();
        } else {
            let newwindow = window.open(url, '_blank');
            if (newwindow) {
                newwindow.onload = () => {
                    newwindow.document.title = name;
                }
            }
        }
        setFileIsLoading('');
    }

    const downloadDocument = (fileName, name) => {
        if (fileIsLoading !== '') {
            return '';
        }
        setFileIsLoading(fileName);
        getDocument(fileName).then(res => {
            if (res.type === ApiResponseType.OK) {
                openFile(res.payload.payload, res.payload.content_type, name);
            }
        });
    }

    return (
        <button className={`item downloadable-file ${isImageFile(item[1].file_name) ? 'image' : 'file'}${fileIsLoading ? ' loading' : ''}`} onClick={() => {downloadDocument(item[1].file_name, item[1].name)}}>
            <div className='file-info'>
                <span className='filetitle'>{item[1].name}</span>
                {/* <span className='filename'>({item[0]})</span> */}
                { item[1].description ? <span className='filedescription'>- {item[1].description}</span> : '' }
            </div>
            { item[1].file_name === fileIsLoading ? <div className="loader"></div> : '' }
        </button>
    )
}

export default FileItem;